(function(){
 function init(el){
  if(el.dataset.ready)return;el.dataset.ready="1";
  var variants=JSON.parse(el.dataset.variants||"[]"),form=document.getElementById(el.dataset.form);
  if(!form)return;
  var idInput=form.querySelector('input[name="id"]'),buttons=Array.from(el.querySelectorAll('[data-qty]'));
  function input(){return form.querySelector('input[name="quantity"]')||document.querySelector('input[name="quantity"][form="'+form.id+'"]')||form.closest('product-form')?.querySelector('input[name="quantity"]');}
  function money(c){try{return new Intl.NumberFormat('en-US',{style:'currency',currency:el.dataset.currency||'USD'}).format(c/100)}catch(e){return '$'+(c/100).toFixed(2)}}
  function render(){
   var variant=variants.find(function(v){return String(v.id)===String(idInput?.value)})||variants[0];if(!variant)return;
   var unit=variant.price,qty=Math.max(1,parseInt(input()?.value||'1',10)||1);
   buttons.forEach(function(btn){
    var n=Number(btn.dataset.qty),raw=n*unit,eligible=el.dataset.eligible==='true',pct=eligible?(n===2?30:n===3?40:0):0;
    btn.setAttribute('aria-pressed',String(qty===n));
    btn.querySelector('[data-total]').textContent=money(Math.round(raw*(100-pct)/100));
    btn.querySelector('span').textContent=n===1?'REGULAR PRICE':pct?'SAVE '+pct+'%':'CONDITIONS APPLY';
   });
   var raw=qty*unit,pct=el.dataset.eligible==='true'&&qty>=3?40:el.dataset.eligible==='true'&&qty>=2?30:0;
   el.querySelector('.orv-bundle__status').textContent=pct?'Estimated '+pct+'% bundle savings: '+money(Math.round(raw*pct/100))+'. Confirm at checkout.':qty===1?'Choose 2 or 3 pairs to see bundle offers.':'Bundle discounts are available on eligible collection styles only.';
  }
  buttons.forEach(function(b){b.addEventListener('click',function(){
    var q=input();if(!q){el.querySelector('.orv-bundle__status').textContent='Use the quantity control below to select '+b.dataset.qty+' pairs.';return}
    q.value=b.dataset.qty;q.dispatchEvent(new Event('input',{bubbles:true}));q.dispatchEvent(new Event('change',{bubbles:true}));render();
  })});
  form.addEventListener('change',render);form.addEventListener('input',render);
  if(idInput)new MutationObserver(render).observe(idInput,{attributes:true,attributeFilter:['value']});
  var previous='';setInterval(function(){var s=(idInput?.value||'')+'|'+(input()?.value||'');if(s!==previous){previous=s;render()}},700);
  render();
 }
 document.querySelectorAll('.orv-bundle').forEach(init);
 document.addEventListener('shopify:section:load',function(){document.querySelectorAll('.orv-bundle').forEach(init)});
})();